import { ComponentProps } from "."
import IsAddHomeVideo from "./IsAddHomeVideo"
import IsCompact from "./IsCompact"
import IsMatchTitleCheckbox from "./IsMatchTitleCheckbox"
import IsSingleSource from "./IsSingleSource"
import IsUHDCheckbox from "./IsUHDCheckbox"
import { Ul } from "./styled"

const ControlCheckboxes = ({
  isAddHomeVideoProps,
  isAdmin,
  isEditor,
  isCompactCheckboxProps,
  isMatchTitleCheckboxProps,
  isSingleSourceCheckboxProps,
  isUHDCheckboxProps
}: ComponentProps) => (
  <Ul aria-label="Control Toggles">
    {(isAdmin || isEditor) && isAddHomeVideoProps ? (
      <li aria-label="Is Add Home Video Toggle">
        <IsAddHomeVideo {...isAddHomeVideoProps} />
      </li>
    ) : null}

    {(isAdmin || isEditor) && isUHDCheckboxProps ? (
      <li aria-label="Is UHD Toggle">
        <IsUHDCheckbox {...isUHDCheckboxProps} />
      </li>
    ) : null}

    {isAdmin && isMatchTitleCheckboxProps ? (
      <li aria-label="Is Match Title Toggle">
        <IsMatchTitleCheckbox {...isMatchTitleCheckboxProps} />
      </li>
    ) : null}

    {isCompactCheckboxProps ? (
      <li aria-label="Is Compact Toggle">
        <IsCompact {...isCompactCheckboxProps} />
      </li>
    ) : null}

    {(isAdmin || isEditor) && isSingleSourceCheckboxProps ? (
      <li aria-label="Is Single Source Toggle">
        <IsSingleSource {...isSingleSourceCheckboxProps} />
      </li>
    ) : null}
  </Ul>
)

export default ControlCheckboxes
